import { useContext } from "react";
import { OfferingsContext } from "./offerings-context";

export function useOfferings() {
  const context = useContext(OfferingsContext);
  if (!context) {
    throw new Error("useOfferings must be used within an OfferingsProvider");
  }
  return context;
}
